import { TouchableOpacity, View } from "react-native";
import React from "react";
import Text from "@components/CustomText";
import color from "@constants/color";
import Reverse from "@assets/svg/MyTasks/Reverse";
import { width } from "@constants/metrics";

function Button({
  title = "",
  btnColor = "",
  backgroundColor = "",
  onPress,
  children,
  textColor,
  icon,
  disabled,
  type = "normal",
  disabledColors = true,
  testID = "mt-button",
}) {
  const Icon = icon === "reverse" ? Reverse : null;

  // Define conditional styles
  const buttonStyle = [
    {
      padding: 10,
      borderWidth: 1,
      borderColor: btnColor || color.blank_grey,
      borderRadius: 8,
      alignItems: "center",
      marginHorizontal: 6,
      justifyContent: "center",
      flexDirection: "row",
      backgroundColor:
        disabled && disabledColors ? "#4E4E4E" : backgroundColor || color.white,
    },
    type === "rounded" ? { width: width / 3.5, borderRadius: 20 } : { flex: 1 },
  ];

  const textStyle = [
    {
      color:
        disabled && disabledColors ? color.white : textColor || color.white,
    },
  ];

  return (
    <TouchableOpacity
      disabled={disabled}
      testID={testID}
      onPress={onPress}
      style={buttonStyle}
      activeOpacity={0.8}
    >
      {Icon ? (
        <View style={{ marginRight: 5, bottom: 1 }}>
          <Icon />
        </View>
      ) : null}
      <Text
        style={textStyle}
        newfont
        variant={type === "rounded" ? "caption_2" : "body_text_4"}
        numberOfLines={1}
      >
        {title}
      </Text>
      {children}
    </TouchableOpacity>
  );
}

export default Button;
